import {Component, h} from 'preact'
import { CategoryInfo, WidgetSetting } from './Types'
import CategoryMenu from './categoryMenu'
import Icon from '../assets'
import Slider from '../slider'
import Search from '../algolia/components/Search'
import Phrase from '../../libs/translationsUtils/phrase'
import Button from '../ui-components/Button'

interface Props {
  items: Array<WidgetSetting>,
  showActivitySinceLastVisit: boolean,
  communityCategories: Array<CategoryInfo>,
  knowledgeBaseCategories: Array<CategoryInfo>,
  logo: string,
  displaySearchInWidget: boolean,
  displayFilters?: boolean,
  searchInfo: {
    isUserGuest: boolean,
    isFederatedSearch: boolean,
    isFederatedSalesforceSearch: boolean,
    isFederatedSkilljarSearch: boolean,
    category?: number,
    groupId?: number,
    isParentCategory?:boolean,
    searchByContentType?: Array<string>
  }
}

interface State {
  extendSearch: boolean,
  isFiltersOverlay: boolean
}

class HeaderNavigation extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      extendSearch: false,
      isFiltersOverlay: false
    }

    this.checkSliderStatus = this.checkSliderStatus.bind(this)
    this.filtersOverlayHandler = this.filtersOverlayHandler.bind(this)
    this.revertFilters = this.revertFilters.bind(this)
  }

  checkSliderStatus (newValue: boolean) {
    const bodyWrapper = window.document.body
    if (newValue) {
      bodyWrapper.classList.add('body-overlay')
    } else {
      bodyWrapper.classList.remove('body-overlay')
    }
  }

  resetFilters (e: Event) {
    e.stopPropagation()
    e.preventDefault()

    window.dispatchEvent(new CustomEvent('resetFilters'))
  }

  revertFilters (e: Event) {
    e.stopPropagation()
    e.preventDefault()

    window.dispatchEvent(new CustomEvent('revertFilters'))
    this.filtersOverlayHandler(e, false)
  }

  filtersOverlayHandler (e: Event, value: boolean) {
    e.stopPropagation()
    e.preventDefault()

    window.dispatchEvent(new CustomEvent('filter', {
      detail: {
        display: value
      }
    }))

    if (value) {
      this.setState({
        isFiltersOverlay: value
      })
    } else {
      /*
        Items that should be in the filters are added via Portal component
        having setTimeout here is making state change async and give time to filter component to unmount
      */
      window.setTimeout(() => {
        this.setState({
          isFiltersOverlay: !this.state.isFiltersOverlay
        })
      }, 0)
    }

    const bodyEl = document.querySelector('body')

    if (bodyEl) {
      if (bodyEl.style.overflow === 'hidden') {
        bodyEl.style.overflow = 'visible'
      } else {
        bodyEl.style.overflow = 'hidden'
      }
    }
  }

  render ({ items, logo, communityCategories, knowledgeBaseCategories, showActivitySinceLastVisit, displaySearchInWidget, searchInfo, displayFilters }: Props,
          { extendSearch, isFiltersOverlay }: State) {
    return (
      <div className={`header-navigation-items_and_search ${extendSearch ? 'search-extended' : ''}`}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className='header-navigation-items_menu'>
            {
              items.filter(item => item.visibility).map((item) => {
                if (item.key === 'community') {
                  if (!communityCategories.length) {
                    return null
                  }
                  return <CategoryMenu
                    name={item.name}
                    showActivitySinceLastVisit={showActivitySinceLastVisit}
                    showHome
                    showRecentlyActive
                    showUnanswered
                    categories={communityCategories}
                  />
                } else if (item.key === 'knowledgeBase') {
                  if (!knowledgeBaseCategories.length) {
                    return null
                  }
                  return <CategoryMenu
                    name={item.name}
                    showActivitySinceLastVisit={false}
                    showHome={false}
                    showRecentlyActive={false}
                    showUnanswered={false}
                    categories={knowledgeBaseCategories}
                  />
                } else {
                  return <a href={item.url} className='header-navigation_link' target={item.external ? '_blank' : ''}> { item.name } </a>
                }
              })
            }
          </div>
          <div className='header-navigation-items_hamburger'>
            <Slider
              title='Menu'
              onCallback={(newValue) => this.checkSliderStatus(newValue)}
              trigger={<Icon icon='menu' />}>
              <div className='header-navigation-items_hamburger-list'>
                {
                  items.filter(item => item.visibility).map((item) => {
                    if (item.key === 'community') {
                      if (!communityCategories.length) {
                        return null
                      }
                      return <CategoryMenu
                        name={item.name}
                        showActivitySinceLastVisit={showActivitySinceLastVisit}
                        showHome
                        showRecentlyActive
                        showUnanswered
                        categories={communityCategories}
                      />
                    } else if (item.key === 'knowledgeBase') {
                      if (!knowledgeBaseCategories.length) {
                        return null
                      }
                      return <CategoryMenu
                        name={item.name}
                        showActivitySinceLastVisit={false}
                        showHome={false}
                        showRecentlyActive={false}
                        showUnanswered={false}
                        categories={knowledgeBaseCategories}
                      />
                    } else {
                      return <a href={item.url} target={item.external ? '_blank' : ''} className='header-navigation_link'> { item.name } </a>
                    }
                  })
                }
              </div>
            </Slider>
          </div>
          {
            logo && (
              <div className='header-navigation_logo-wrapper is-hidden-L'>
                <a href='/' target='_self' className='header-navigation_logo-anchor'>
                  <img className='header-navigation_logo' src={logo} title='' alt='Logo' />
                </a>
              </div>
            )
          }
        </div>
        {
          displaySearchInWidget ? (
            <div className={`header-navigation_extendable-search ${extendSearch ? 'extended' : ''}`}>
              <div className={`header-navigation_extended-search ${!extendSearch ? 'is-hidden' : ''}`}>
                <form>
                  <Search {...searchInfo} />
                </form>
                <button
                  type='button'
                  className='btn btn--secondary close-icon header-navigation_extendable-search-icon'
                  onClick={() => this.setState({ extendSearch: false })}>
                  <Icon icon='close' width={16} height={16} />
                </button>
              </div>
              <button
                type='button'
                className={`btn btn--secondary search-icon header-navigation_extendable-search-icon ${extendSearch ? 'is-hidden' : ''}`}
                onClick={() => this.setState({ extendSearch: true })}>
                <Icon icon='search' width={16} height={16} />
              </button>
              {
                displayFilters ? (
                  <button className='instant-search__filter is-hidden-S'
                          onClick={(e: Event) => this.filtersOverlayHandler(e, true)}>
                    <Icon width={18} height={12} color='#6B707E' icon='filter' />
                  </button>
                ) : null
              }
              {
                isFiltersOverlay ? (
                  <div className={`instant-search__results-wrapper is-hidden-L ${!isFiltersOverlay ? '' : ''}`}>
                    <div
                      className={`instant-search__results-wrapper-filter ${!isFiltersOverlay
                        ? 'instant-search__results-wrapper-filter--hide'
                        : ''}`}>
                      <div className='instant-search__results-wrapper-filter-header'>
                        <Icon icon='close' onClick={this.revertFilters} />
                        <h3
                          className='instant-search__results-wrapper-filter-header-heading'>
                          <Phrase p='advanced.search.filters' />
                        </h3>
                        <button
                          onClick={this.resetFilters}
                          className='instant-search__results-wrapper-filter-header-btn'>
                          <Phrase m='Common' p='advanced.search.filter.clear.all' />
                        </button>
                      </div>
                      {
                        /*
                        * Filters can be added via Portal component from real place of filters.
                        * Since Search does not include them it does not care about which items needs to be display in which order,
                        * all those decisions can be done on filter component
                        * */
                      }
                      <div className='instant-search__results-wrapper-filters'>
                      </div>
                      <div
                        className='instant-search__results-wrapper-filter-show-more-wrapper'>
                        <Button
                          cta
                          class='instant-search__results-wrapper-filter-show-more'
                          onClick={(e: Event) => this.filtersOverlayHandler(e, false)}
                        >
                          <Phrase p='show.results'/>
                        </Button>
                      </div>
                    </div>
                  </div>
                ) : null
              }
            </div>
          ) : null
        }
      </div>
    )
  }
}

export default HeaderNavigation
